import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { SearchEnginesCrawlBlockers } from '../../../constants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Reason = ({
  searchEnginesCrawlBlocker
}) => {
  switch (searchEnginesCrawlBlocker) {
    case SearchEnginesCrawlBlockers.NOINDEX_META_TAG:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.reasons.MAKE_PAGE_INDEXABLE_BY_SEARCH_ENGINES.NOINDEX_META_TAG"
      });
    default:
      console.error('No translation found for this search engines crawl blocker issue: ', searchEnginesCrawlBlocker);
      return null;
  }
};
export const MakePageIndexableBySearchEnginesView = ({
  auditResult
}) => {
  const {
    status,
    searchEnginesCrawlBlocker
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.MAKE_PAGE_INDEXABLE_BY_SEARCH_ENGINES"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.MAKE_PAGE_INDEXABLE_BY_SEARCH_ENGINES"
    }),
    status: status,
    children: searchEnginesCrawlBlocker && /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      as: "div",
      children: /*#__PURE__*/_jsx(Reason, {
        searchEnginesCrawlBlocker: searchEnginesCrawlBlocker
      })
    })
  });
};